import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
    {
      navCap: 'Patient menu',
    },
    {
      displayName: 'Patient data',
      iconName: 'ticket',
      route: '/dossier/personal-data',
    },
    {
      displayName: 'Symptoms',
      iconName: 'chart-pie',
      route: '/dossier/symptoms',
    },
    {
      displayName: 'Alerts',
      iconName: 'flag',
      route: '/dossier/alerts',
    },
    {
      displayName: 'Care Plans',
      iconName: 'certificate',
      route: '/dossier/cpr-treatment',
    },
    {
      displayName: 'Consent',
      iconName: 'checklist',
      route: '/dossier/consent',
    },
    {
      displayName: 'Meds & Allergies',
      iconName: 'checklist',
      route: '/dossier/drugs',
    },
    {
      displayName: 'Prognosis',
      iconName: 'edit',
      route: '/dossier/prognosis',
    },
    {
      displayName: 'Conctacts',
      iconName: 'edit',
      route: '/dossier/contacts',
    },
    {
      displayName: 'Bangle',
      iconName: 'edit',
      route: '/dossier/bangle',
    }
];
